import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { FiLayout, FiSmartphone, FiActivity, FiClock } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Features() {
  const { t } = useLanguage();

  const features = [
    { icon: FiLayout, title: t('features.f1') },
    { icon: FiSmartphone, title: t('features.f2') },
    { icon: FiActivity, title: t('features.f3') },
    { icon: FiClock, title: t('features.f4') },
  ];

  return (
    <section className="py-24 bg-brand-dark border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {features.map((feature, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="text-center group"
            >
              <div className="w-16 h-16 mx-auto bg-gray-800 rounded-full flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                <SafeIcon icon={feature.icon} className="text-2xl text-blue-400 group-hover:text-white transition-colors" />
              </div>
              <h4 className="text-lg font-semibold text-white">{feature.title}</h4>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}